import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

const TodoListItems = ({alltask, setTaskComplete}) => {
    return (
            <div className="todo-list-items">
                <div className="heading">
                    <h3>All Task for Event</h3>
                </div>
                <div className="task-content">
                {alltask && alltask.length > 0 && 
                    alltask.map((task) => (
                    <div className={task.isDone ? "task-card active" : "task-card"} key={task.id}>
                        <h6>{task.title && task.title}</h6>
                        <div className="controler">
                            <FontAwesomeIcon onClick={() => setTaskComplete(task.id, task.isDone ? 0 : 1)} style={{color: "#FFF"}} icon={faCheck} />
                        </div>
                    </div>
                    ))}

                </div>
            </div>
        );
};

export default TodoListItems;
